import React from "react";
import { LinkCustomerInformationsType } from "../../../common/types";




type Props = {
    customerInformations: LinkCustomerInformationsType | undefined,
    linkDesc?: string
}
const CustomerInformations = ({ customerInformations, linkDesc }: Props) => {



    return (
        <div>

            <h1 className="font-bold text-contrast-90 text-xl px-2">
                Müşteri Bilgileri
            </h1>

            <div className="grid grid-cols-4 grid-rows-3 gap-4 ">
                {customerInformations?.customerName && (
                    <>
                        <span>Müşteri Adı</span>
                        <span className="col-span-3">
                            {customerInformations?.customerName}
                        </span>
                    </>
                )}
                {customerInformations?.email && (
                    <>
                        <span>Müşteri Email</span>
                        <span className="col-span-3">
                            {customerInformations?.email}
                        </span>
                    </>
                )}
                {customerInformations?.phone && (
                    <>
                        <span>Müşteri Telefon</span>
                        <span className="col-span-3">
                            {customerInformations?.phone}
                        </span>
                    </>
                )}
                {customerInformations?.taxOffice && (
                    <>
                        <span>Vergi Dairesi</span>
                        <span className="col-span-3">
                            {customerInformations?.taxOffice}
                        </span>
                    </>
                )}
                {customerInformations?.country && (
                    <>
                        <span>Ülke</span>
                        <span className="col-span-3">
                            {customerInformations?.country}
                        </span>
                    </>
                )}
                {customerInformations?.city && (
                    <>
                        <span>Şehir</span>
                        <span className="col-span-3">
                            {customerInformations?.city}
                        </span>
                    </>
                )}
                {customerInformations?.district && (
                    <>
                        <span>İlçe</span>
                        <span className="col-span-3">
                            {customerInformations?.district}
                        </span>
                    </>
                )}
                {linkDesc && (
                    <>
                        <span>Ödeme Açıklaması</span>
                        <span className="col-span-3">
                            {linkDesc}
                        </span>
                    </>
                )}
            </div>
        </div>
    );
}
export default CustomerInformations;